import { Quote, Crown } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FOUNDER_WORDS = [
  {
    quote: "We faced different challenges but the same frustration — important information was right in front of us, yet accessing and understanding it wasn't always easy.",
    name: "The Founder",
    role: "Living with macular degeneration",
    testid: "story-card-founder-1",
  },
  {
    quote: "VoiceLens AI was created to help people regain independence through AI-powered reading and understanding.",
    name: "The Founder",
    role: "Raising a son with dyslexia",
    testid: "story-card-founder-2",
  },
];

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32" aria-labelledby="voices-heading">
      <span id="voices-heading" className="sr-only">Why VoiceLens AI exists</span>
      <SectionHeading
        align="center"
        eyebrow={{ index: "05", label: "Why We Exist" }}
        title={<>Real words. <span className="text-glow-gradient">Real reasons.</span></>}
        sub="VoiceLens AI just launched — so instead of invented reviews, here are the true words this app was built on. Reader stories will live here as they arrive."
      />

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {FOUNDER_WORDS.map((t, i) => (
          <Reveal key={t.testid} delay={i * 0.1}>
            <figure
              data-testid={t.testid}
              className="card-glow glass-panel flex h-full flex-col rounded-3xl p-8"
            >
              <Quote className="h-8 w-8 fill-[#00D4FF]/20 text-[#00D4FF]" aria-hidden="true" />
              <blockquote className="mt-5 flex-1 text-base leading-relaxed text-slate-200 sm:text-lg">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-slate-500/25 pt-5">
                <p className="font-display font-bold text-white">— {t.name}</p>
                <p className="text-sm text-slate-400">{t.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}

        <Reveal delay={0.2}>
          <div
            className="flex h-full flex-col justify-center rounded-3xl border border-[#2563EB]/40 bg-gradient-to-br from-[#2563EB]/25 to-[#00D4FF]/10 p-8"
            data-testid="first-readers-card"
          >
            <Crown className="h-8 w-8 text-[#00D4FF]" aria-hidden="true" />
            <p className="font-display mt-4 text-lg font-bold leading-snug text-white sm:text-xl">
              Your story could be the first one here.
            </p>
            <p className="mt-3 text-base leading-relaxed text-slate-300">
              Become a Founder, try VoiceLens AI, and tell us what it changed for you — we'll
              feature real reader stories right here.
            </p>
            <a
              href="/#pricing"
              data-testid="first-readers-cta"
              className="mt-6 inline-flex min-h-[52px] items-center justify-center rounded-full bg-[#2563EB] px-7 py-3.5 text-base font-bold text-white transition-all duration-300 hover:bg-[#1D4ED8]"
            >
              Become a Founder
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
